import React from 'react';
import { useSelector } from 'react-redux';
import styles from './CategoryInfo.styles';
import { selectSelectedCategory } from '../../redux/store/userData/categories/selectors';
import { selectBrands } from '../../redux/store/appData/fleets';

const detailList = [
  {
    label: 'Brand',
    value: 'brandId',
  },
  {
    label: 'Acriss Code',
    value: 'acrissCode',
  },
  {
    label: 'Description',
    value: 'description',
  },
];

const CategoryInfo: React.FC = () => {
  const selectedCategory = useSelector(selectSelectedCategory);
  const brands = useSelector(selectBrands);

  return (
    <>
      <div className="area-info">
        {detailList.map((detail, i) => (
          <div key={`area-detail-${i}`}>
            <p data-testid={`CategoryInfo-${detail.label}`} className="label">
              {detail.label}
            </p>
            <p className="value">
              {!selectedCategory[detail.value] && '-'}
              {detail.label === 'Brand'
                ? brands?.find((brand) => brand.id === selectedCategory.brandId)
                    ?.name
                : selectedCategory[detail.value]}
            </p>
          </div>
        ))}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default CategoryInfo;
